
import { ChartCard } from "../chart-utils/ChartCard";
import { ClientPieChart } from "./client/ClientPieChart";
import { ClientLegend } from "./client/ClientLegend";

interface ClientRevenueChartProps {
  data: { name: string; value: number; }[];
}

export const ClientRevenueChart = ({ data }: ClientRevenueChartProps) => {
  return (
    <ChartCard
      title="Top Clients by Revenue"
      description="Revenue breakdown by client"
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="flex items-center justify-center">
          <ClientPieChart data={data} />
        </div>
        <div className="space-y-4">
          <ClientLegend data={data} />
        </div>
      </div>
    </ChartCard>
  );
};
